export default __webpack_public_path__ + "static/media/front.2be8789e.png";